import { Link } from "react-router-dom";
import MovieCard from "@/components/feature/MovieCard";
import { allMovies } from "@/lib/movies";
import { useFavorites } from "@/hooks/useFavorites";

export default function FavoritesSection() {
  const { favorites } = useFavorites();
  const saved = allMovies.filter((movie) => favorites.includes(movie.id));

  return (
    <section className="px-4 md:px-8 lg:px-12 py-12 md:py-16">
      <div className="max-w-shell mx-auto">
        <div className="rounded-lg border border-background-200/70 bg-background-100/40 p-5 md:p-7">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-5">
            <div className="flex items-center gap-3">
              <span className="w-9 h-9 rounded-md bg-primary-500/15 text-primary-400 flex items-center justify-center">
                <i className="ri-bookmark-line text-lg" aria-hidden="true"></i>
              </span>
              <div>
                <h2 className="font-heading text-lg text-foreground-950 font-semibold">我的片单</h2>
                <p className="text-xs text-foreground-500 mt-0.5">
                  收藏保存在当前浏览器，共 {saved.length} 部影片
                </p>
              </div>
            </div>
            <Link
              to="/category/all"
              className="text-xs text-primary-500 hover:text-primary-400 transition-colors flex items-center gap-1 whitespace-nowrap cursor-pointer"
            >
              去片库看看
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>

          {saved.length > 0 ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
              {saved.slice(0, 8).map((movie) => (
                <MovieCard key={movie.id} movie={movie} compact />
              ))}
            </div>
          ) : (
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 rounded-md border border-dashed border-background-300/80 px-5 py-6">
              <p className="text-sm text-foreground-600 leading-relaxed">
                还没有收藏任何影片。在影片详情页点击「加入片单」，就能在这里快速找回。
              </p>
              <Link
                to="/category/drama"
                className="h-9 px-4 rounded-md border border-background-300 text-foreground-800 text-sm flex items-center gap-2 hover:border-primary-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer shrink-0"
              >
                从剧情伦理开始
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}